import { ReactElement } from 'react'
import styled from 'styled-components';

import { EmptyState as ToqioEmptyState } from '@toqio/toqio-web-components';
import { PlaceholderProps, TITLE_SIZE, TITLE_WEIGHT } from './placeholder.types'

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

/** PLACEHOLDER */
export const Placeholder = ({
  visible = false,
  title = '',
  description = '',
  titleSize = TITLE_SIZE.S,
  titleWeight = TITLE_WEIGHT.BOLD,
  illustration = "",
  firstButton = undefined,
  secondButton = undefined,
  containerClassName = '',
  className = '',
  style = {},
  children,
}: PlaceholderProps): ReactElement | null => {
  if (visible) {
    return (
      <StyledContainer className={containerClassName}>
        <ToqioEmptyState
          illustration={illustration}
          title={title}
          titleSize={titleSize}
          titleWeight={titleWeight}
          description={description}
          firstButton={firstButton}
          secondButton={secondButton}
          className={className}
          style={style}
        />
        {children}
      </StyledContainer>
    )
  }

  return null
}